import React, { useEffect, useState } from "react";
import styles from "../styles/Modal.module.css";
import { useStoredState, useStoredMoves } from "../customHooks/useStoredState";

function HighscoreModal({ setModalOpen, moves, time}) {
  const [note, setNote] = useState("");
 // const [time, setTime] = useStoredState(2, "storeTime");
  const API =
    "https://e895ifjq5f.execute-api.us-east-1.amazonaws.com/submit-score";
  // const hours = Math.floor(time / 3600);
  // const minutes = Math.floor((time % 3600) / 60);
  // const seconds = time % 60;
  const [playerName, setPlayerName] = useState("");

  const totalMilliseconds = Math.floor(time);
  const hours = Math.floor(totalMilliseconds / 3600000);
  const minutes = Math.floor((totalMilliseconds % 3600000) / 60000);
  const seconds = Math.floor((totalMilliseconds % 60000) / 1000);
  const milliseconds = totalMilliseconds % 1000;

  function formatScore() {
    const msTime = Math.floor(time);
    const stringTime = msTime.toString().padStart(8, "0");
    const stringMoves = moves.toString().padStart(3, "0");

    return `${stringTime}#${stringMoves}#${playerName}`;
  }
  const handleNameChange = (e) => {
    setPlayerName(e.target.value);
  };

  async function handleSubmit(event) {
    if (playerName.trim() === "") {
      setNote("Please enter your player name.");
      return;
    }

    setNote("");

    const score = formatScore();
    const scoreType = "ALLTIME";
    const msTime = Math.floor(time);
    const payload = {
      scoreType,
      playerName,
      score,
      msTime,
      moves,
    };

    try {
      setNote("Submitting Score..");
      const res = await fetch(
        "https://iceyha0u6a.execute-api.us-east-1.amazonaws.com/dev/submitScore",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const result = await res.json();

      if (!res.ok) {
        setNote(result.message || "Failed to submit score, please try again.");
        return;
      }
      setNote(result.message || "Score submitted!");
      setTimeout(() => {
        setModalOpen(false);
      }, 2250);
      //setModalOpen(false);
      //set message ro result, name and time back to null.
    } catch (error) {
      console.error("Submit error:", error);
      setNote(
        "Error submitting score. Please check connection & please try again"
      );
    }
  }

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalBox}>
        <div className={styles.modal}>
          <h4 className={styles.youMadeIt}>
            You have made it onto the Highscores Board!
          </h4>
          <h3 className={styles.congratulations}>
            <span className={styles.red}>C</span>
            <span className={styles.blue}>o</span>
            <span className={styles.green}>n</span>
            <span className={styles.yellow}>g</span>
            <span className={styles.red}>r</span>
            <span className={styles.blue}>a</span>
            <span className={styles.green}>t</span>
            <span className={styles.yellow}>u</span>
            <span className={styles.red}>l</span>
            <span className={styles.blue}>a</span>
            <span className={styles.green}>t</span>
            <span className={styles.yellow}>i</span>
            <span className={styles.red}>o</span>
            <span className={styles.blue}>n</span>
            <span className={styles.green}>s</span>
            <span className={styles.yellow}>!</span>
          </h3>

          <h4 className={styles.modalTime}>
            TIME: {hours.toString().padStart(2, "0")}:
            {minutes.toString().padStart(2, "0")}:
            {seconds.toString().padStart(2, "0")}:
            {milliseconds.toString().padStart(2, "0")}
          </h4>
          <h4 className={styles.modalMoves}>MOVES: {moves}</h4>
          <p className={styles.note}>{note}</p>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <label className={styles.nameLabel} name="playerName">
              Enter player name.
              <br />
              <input
                autoComplete="off"
                name="playerName"
                className={styles.nameInput}
                type="text"
                value={playerName}
                maxLength={6}
                placeholder=""
                required
                onChange={(e) => handleNameChange(e)}
              />
            </label>
          </form>
          <div className={styles.modalActions}>
            <button type="submit" onClick={() => handleSubmit()}>
              Submit
            </button>
            <button type="button" onClick={() => setModalOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default HighscoreModal;
